import { SvelteComponent } from 'svelte/internal';
import { writable } from 'svelte/store';

// Identifiable tag for routing (e.g. events, activities, activityView)
export type RouteId = 'eventList' | 'activityList' | 'activityView';
export type RouteCategory = 'events' | 'activities';

export const currentPage = writable<{
  id: RouteId;
  category: string;
  component: SvelteComponent;
} | null>(null);
